/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Col_SampleInputs */

const en_salary_col_sample = /** @type {(inputs: Salary_Col_SampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sample`)
};

const de_salary_col_sample = /** @type {(inputs: Salary_Col_SampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stichprobe`)
};

const fr_salary_col_sample = /** @type {(inputs: Salary_Col_SampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échantillon`)
};

const es_salary_col_sample = /** @type {(inputs: Salary_Col_SampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muestra`)
};

const it_salary_col_sample = /** @type {(inputs: Salary_Col_SampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campione`)
};

const nl_salary_col_sample = /** @type {(inputs: Salary_Col_SampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Steekproef`)
};

const pl_salary_col_sample = /** @type {(inputs: Salary_Col_SampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próba`)
};

const fi_salary_col_sample = /** @type {(inputs: Salary_Col_SampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otos`)
};

const da_salary_col_sample = /** @type {(inputs: Salary_Col_SampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stikprøve`)
};

const sv_salary_col_sample = /** @type {(inputs: Salary_Col_SampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Urval`)
};

/**
* | output |
* | --- |
* | "Sample" |
*
* @param {Salary_Col_SampleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_col_sample = /** @type {((inputs?: Salary_Col_SampleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Col_SampleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_col_sample(inputs)
	if (locale === "fr") return fr_salary_col_sample(inputs)
	if (locale === "es") return es_salary_col_sample(inputs)
	if (locale === "it") return it_salary_col_sample(inputs)
	if (locale === "nl") return nl_salary_col_sample(inputs)
	if (locale === "pl") return pl_salary_col_sample(inputs)
	if (locale === "fi") return fi_salary_col_sample(inputs)
	if (locale === "da") return da_salary_col_sample(inputs)
	if (locale === "sv") return sv_salary_col_sample(inputs)
	return en_salary_col_sample(inputs)
});